import { render, staticRenderFns } from "./PainTherapy.vue?vue&type=template&id=77cb52ea&"
import script from "./PainTherapy.vue?vue&type=script&lang=ts&"
export * from "./PainTherapy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports